// extracted by mini-css-extract-plugin
export default {"primaryColor":"#50b3f6","tinyEditorHeight":"650","trendingNewsDefaultColor":"#495057","smallDevice":"768px","fontBold":"700","fontNormal":"400"};